export default {
  services: {
    auth: {
      name: 'Аутентификация'
    }
  }
}